/**
 * Permissoes do usuario logado, como LISTA.
 *
 * O portal nasceu assumindo que cada usuario tem uma permissao so, e comparava
 * com ===. Quem tem mais de um perfil ficava sem menu nenhum: o auth-server
 * devolve uma lista, o localStorage.setItem coage array para string, e o que
 * sobrava era "ROLE_USUARIO,ROLE_CONTADOR" - que nao e igual a nenhum nome de
 * role isolado.
 *
 * Pior: o TIPO mudava conforme o momento. Logo apos o login, a mutation
 * setUserPermission recebia o ARRAY vindo da API; depois de um F5, o mesmo
 * campo virava a STRING relida do localStorage. Comparacao por === falhava nos
 * dois casos, por motivos diferentes.
 *
 * Daqui para frente ha um so ponto que normaliza os tres formatos possiveis.
 */

/**
 * Aceita array, string separada por virgula, null/undefined - e sempre devolve
 * um array de nomes de role, sem vazios e sem espaco em volta.
 */
export function normalizarPermissoes(valor) {
    if (valor === null || valor === undefined) return []

    const bruto = Array.isArray(valor) ? valor : String(valor).split(',')

    return bruto
        .map(permissao => String(permissao).trim())
        .filter(permissao => permissao.length > 0)
}

/**
 * O usuario alcanca o item quando tem PELO MENOS UMA das permissoes que ele
 * exige. Lista de exigidas vazia (ou ausente) nao libera nada - e o mesmo
 * comportamento de antes, em que um item sem `permissoes` nunca aparecia.
 */
export function temAlgumaPermissao(doUsuario, exigidas) {
    if (!Array.isArray(exigidas) || exigidas.length === 0) return false

    const minhas = normalizarPermissoes(doUsuario)

    return exigidas.some(permissao => minhas.includes(permissao))
}
